// import React, { useContext, useEffect, useState } from 'react'
// import { Images } from "constants";
// import { dashboardCount } from '_services/dashboardService/dashboardService';
// import toast from 'react-hot-toast';
// import StorageService from 'utils/StorageServices/StorageServices';
// import { UserContext } from 'context';
// import { CommonDateRange, CustomSelect, PieCharts } from 'components';
// import moment from 'moment';
// import { getBranchDropdownListData } from '_services/dropdownServices/dropdownService';
// import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { useDispatch } from 'react-redux';
// import { updateInputValue } from 'features/lrFilterServices/lrFilterSlice';
// import useDocumentTitle from 'hooks/useDocumentTitle';
// import { updateEwayBillFilters } from 'features/ewayBillFilterServices/ewayBillFilterSlice';

// const MainDashboard = () => {
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const getFiltersValues = useSelector((state) => state.lrFilter)?.filters;
//     const getEwayBillFilters = useSelector((state) => state.ewayBillFilter)?.filters;
//     const { masterData, userData, dashboardFilterClear, setDashboardFilterClear } = useContext(UserContext)

//     const [selectedRange, setSelectedRange] = useState({
//         startDate: '',
//         endDate: '',
//     });
//     const [dashboardFilter, setDashboardFilter] = useState({
//         company_id: StorageService.getCompanyId(),
//         branch_id: '',
//         consignor_id: '',
//         start_date: '',
//         end_date: '',
//     })
//     const [dashboardData, setDashBoardData] = useState({});
//     const [dropdownBranchList, setDropdownBranchList] = useState([]);
//     const [chartData, setChartData] = useState([]);

//     const conmanyId = StorageService.getCompanyId()

//     useDocumentTitle("Dashboard | T360");

//     useEffect(() => {
//         if (conmanyId != "undefined") {
//             getMainDashboard();
//         }

//     }, [dashboardFilter, selectedRange, conmanyId])

//     const getMainDashboard = async () => {
//         try {
//             let object = {
//                 company_id: StorageService.getCompanyId(),
//                 branch_id: dashboardFilter?.branch_id?.value ? dashboardFilter?.branch_id?.value : '',
//                 consignor_id: dashboardFilter?.consignor_id?.value ? dashboardFilter?.consignor_id?.value : '',
//                 // start_date: selectedRange.startDate ? moment(new Date(selectedRange.startDate)) : '',
//                 // end_date: selectedRange.endDate ? moment(new Date(selectedRange.endDate)) : '',
//                 start_date: selectedRange?.startDate ? moment(selectedRange?.startDate)?.format("YYYY-MM-DD") : '',
//                 end_date: selectedRange?.endDate ? moment(selectedRange?.endDate)?.format("YYYY-MM-DD") : '',
//             }
//             const res = await dashboardCount(object);
//             if (res?.responseCode === 200) {
//                 setDashBoardData(res?.data)
//                 // toast.success(`${res?.responseMessage}`);
//                 getDataForChart(res?.data?.trip_status)
//             } else {
//                 toast.error(`${res?.responseMessage}`);
//             }
//         } catch (error) {
//             toast.error(error.message);
//         }
//     };

//     const onhandleSelect = async (item, name) => {
//         const stateObj = { ...dashboardFilter, [name]: item };
//         setDashboardFilter(stateObj);
//         const obj = {
//             ...getFiltersValues,
//             branch_id: item,
//             start_date: selectedRange?.startDate ? moment(selectedRange?.startDate)?.format("YYYY-MM-DD") : '',
//             end_date: selectedRange?.endDate ? moment(selectedRange?.endDate)?.format("YYYY-MM-DD") : '',
//             // start_date: selectedRange?.startDate,
//             // end_date: selectedRange?.endDate,
//             lr_pagination: 1
//         }
//         dispatch(updateInputValue(obj))
//     };

//     const getDataForChart = (data) => {
//         const trip_status = data
//         const selectedStatuses = ["at_party", "in_transit", "delivered", "cancelled"];

//         const filteredTripStatusArray = selectedStatuses?.map(status => ({
//             name: status,
//             value: trip_status[status]
//         }));
//         setChartData(filteredTripStatusArray)
//     }

//     const getDropdownDataBranchList = async () => {
//         try {
//             let object = {
//                 company_id: StorageService.getCompanyId(),
//                 limit: 100,
//                 offset: 1,
//                 search: "",
//             };
//             const res = await getBranchDropdownListData(object);
//             if (res?.responseCode == 200) {
//                 setDropdownBranchList([{ branch: "All", _id: "" }, ...res?.data?.branch_list]);
//             }
//         } catch (error) {
//             // throw error;
//         }
//     };

//     useEffect(() => {
//         if (conmanyId != "undefined") {
//             getDropdownDataBranchList();
//         }

//     }, [conmanyId])

//     const handleApply = (newRange) => {
//         setSelectedRange(newRange);
//         const obj = {
//             ...getFiltersValues,
//             start_date: newRange?.startDate,
//             end_date: newRange?.endDate,
//             lr_status: 0,
//             lr_pagination: 1
//         }
//         dispatch(updateInputValue(obj))
//     };

//     const statusWithNavigate = (value, is_action) => {
//         navigate('/lr/addlr');
//         if (!is_action) {
//             setSelectedRange({
//                 startDate: '',
//                 endDate: '',
//             })
//             const obj = {
//                 ...getFiltersValues,
//                 start_date: '',
//                 end_date: '',
//                 lr_status: value,
//                 lr_pagination: 1
//             }
//             dispatch(updateInputValue(obj))
//         }
//     }

//     const handleApplyFilter = (object) => {
//         const obj = {
//             ...getFiltersValues,
//             pod_status: object,
//             lr_status: 0,
//             lr_pagination: 1
//         }
//         dispatch(updateInputValue(obj))
//         navigate('/lr/addlr');
//     }

//     useEffect(() => {
//         if (dashboardFilterClear) {
//             const obj = {
//                 ...getFiltersValues,
//                 branch_id: { label: "All", value: "" },
//                 lr_status: 0,
//                 lr_pagination: 1
//             }
//             dispatch(updateInputValue(obj))
//             setDashboardFilterClear(false);
//         }
//     }, [dashboardFilterClear])

//     const ewayBillApplyFilter = (value) => {
//         const obj = {
//             ...getEwayBillFilters,
//             branch_id: getFiltersValues?.branch_id?.value ? getFiltersValues?.branch_id?.value : '',
//             // start_date: selectedRange?.startDate,
//             // end_date: selectedRange?.endDate,
//             eway_bill_status: value,
//             offset: 1
//         }
//         dispatch(updateEwayBillFilters(obj));
//         navigate('/ebill');
//     }

//     console.log('dashboardData', dashboardData?.accounting_list)

//     return (
//         <div className="llt_dashboard_bx">
//             <div className="llt_dash_heading">
//                 <h5>Welcome {userData?.user_detail?.full_name}</h5>
//                 <div className="llt_dash_branch_date">
//                     <div>
//                         <CustomSelect
//                             options={dropdownBranchList?.map((el) => {
//                                 return {
//                                     label: el?.branch,
//                                     value: el?._id,
//                                 }
//                             })}
//                             name="branch_id"
//                             label="Select Branch"
//                             placeholder="Select Branch"
//                             value={getFiltersValues?.branch_id?.label ? getFiltersValues?.branch_id : {}}
//                             onSelect={(data) => onhandleSelect(data, 'branch_id')}
//                         />
//                     </div>

//                     <div>
//                         <CommonDateRange
//                             initialStartDate={dashboardData.start_date}
//                             initialEndDate={dashboardData.end_date}
//                             onApply={handleApply}
//                             isDefaultToday={true}
//                         // datePrefield={(!dashboardData?.start_date && !dashboardData?.end_date) ? false : true}
//                         />
//                     </div>

//                 </div>
//             </div>
//             <div className="row dash_row">
//                 <div className="col-12 col-md-6 col-lg-6 col-xl-4">
//                     <div className="llt_dash_lr_stats">
//                         <h6>LR Status</h6>

//                         <div className="llt_dash_lr_r1">
//                             <div className="llt_dash_lr_sts_one">
//                                 <span className="llt_dash_span_one"></span> <p>LR Created</p>
//                             </div>
//                             <button className="llt_dash_btn_one" onClick={() => statusWithNavigate(0, true)}>{dashboardData?.lr_status?.lr_created}</button>
//                         </div>
//                         <div className="llt_dash_lr_r1">
//                             <div className="llt_dash_lr_sts_one">
//                                 <span className="llt_dash_span_two"></span> <p>LR Pending</p>
//                             </div>
//                             <button className="llt_dash_btn_two" onClick={() => statusWithNavigate(1, false)}>{dashboardData?.lr_status?.pending_lr}</button>
//                         </div>
//                         <div className="llt_dash_lr_r1">
//                             <div className="llt_dash_lr_sts_one">
//                                 <span className="llt_dash_span_three"></span>
//                                 <p>In-Transit</p>
//                             </div>
//                             <button className="llt_dash_btn_three" onClick={() => statusWithNavigate(3, false)}>{dashboardData?.lr_status?.in_transit}</button>
//                         </div>
//                         <div className="llt_dash_lr_r1">
//                             <div className="llt_dash_lr_sts_one">
//                                 <span className="llt_dash_span_four"></span>
//                                 <p>At Party Point</p>
//                             </div>
//                             <button className="llt_dash_btn_four" onClick={() => statusWithNavigate(4, false)}>{dashboardData?.lr_status?.at_party_point}</button>
//                         </div>
//                         <div className="llt_dash_lr_r1">
//                             <div className="llt_dash_lr_sts_one">
//                                 <span className="llt_dash_span_five"></span> <p>Delivered</p>
//                             </div>
//                             <button className="llt_dash_btn_five" onClick={() => statusWithNavigate(5, true)}>{dashboardData?.lr_status?.delivered}</button>
//                         </div>
//                         <div className="llt_dash_lr_r1">
//                             <div className="llt_dash_lr_sts_one">
//                                 <span className="llt_dash_span_six"></span> <p>Bill Raised</p>
//                             </div>
//                             <button className="llt_dash_btn_six" onClick={() => statusWithNavigate(6)}>{dashboardData?.lr_status?.bill_raised}</button>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="col-12 col-md-6 col-lg-6 col-xl-4">
//                     <div className="llt_dash_lr_stats">
//                         <h6>Dispatch Summary</h6>
//                         <div className="llt_dash_dispatch">

//                             <PieCharts
//                                 dataList={
//                                     chartData?.length > 0
//                                         ? chartData
//                                         : []
//                                 }
//                             />
//                         </div>
//                     </div>
//                 </div>
//                 <div className="col-12 col-md-6 col-lg-6 col-xl-4">
//                     <div className="llt_dash_pod_vehicle">
//                         <div className="llt_dash_pod">
//                             <h6>POD Status</h6>
//                             <div className="llt_dash_pod_data">
//                                 <div
//                                     className="llt_dash_pod_d1 _avPointer"
//                                     onClick={() => handleApplyFilter({ value: 2, label: "Received" })}>
//                                     <h5>{dashboardData?.lr_status?.pod_received}</h5>
//                                     <p>Received</p>
//                                 </div>
//                                 <div
//                                     className="llt_dash_pod_d12 _avPointer"
//                                     onClick={() => handleApplyFilter({ value: 1, label: "Pending" })}>
//                                     <h5>{dashboardData?.lr_status?.pod_pending}</h5>
//                                     <p>Pending</p>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="llt_dash_pod">
//                             <h6>Vehicle Document</h6>
//                             <div className="llt_dash_pod_data">
//                                 <div className="llt_dash_vehicle_d1">
//                                     <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="28"
//                                         height="28"
//                                         viewBox="0 0 28 28"
//                                         fill="none"
//                                     >
//                                         <rect width="28" height="28" rx="2" fill="#FFF6F2" />
//                                         <path
//                                             d="M15.4881 4.68523C15.4881 4.30844 15.8496 4 16.3022 4C16.7548 4 17.1163 4.3051 17.1163 4.68523V7.67623C17.1163 8.05135 16.7548 8.36145 16.3022 8.36145C15.8496 8.36145 15.4881 8.05468 15.4881 7.67623V4.68523ZM6.37057 17.1611H8.23315C8.29045 17.1615 8.34528 17.185 8.3858 17.2265C8.42632 17.268 8.44927 17.3241 8.44969 17.3828V18.7949C8.44927 18.8536 8.42632 18.9098 8.3858 18.9512C8.34528 18.9927 8.29045 19.0162 8.23315 19.0167H6.36568C6.30853 19.0162 6.25387 18.9927 6.21361 18.9511C6.17336 18.9096 6.15077 18.8535 6.15077 18.7949V17.3828C6.15077 17.3243 6.17336 17.2681 6.21361 17.2266C6.25387 17.1851 6.30853 17.1615 6.36568 17.1611H6.37057ZM13.5165 13.1347H15.3839C15.4389 13.135 15.4918 13.1565 15.5321 13.1947C14.8003 13.6642 14.1645 14.2745 13.6597 14.992H13.5165C13.4593 14.9916 13.4046 14.968 13.3644 14.9265C13.3241 14.8849 13.3015 14.8288 13.3015 14.7703V13.3565C13.3015 13.2979 13.3241 13.2418 13.3644 13.2002C13.4046 13.1587 13.4593 13.1352 13.5165 13.1347ZM9.93455 13.1347H11.815C11.8722 13.1347 11.927 13.1578 11.9676 13.1991C12.0082 13.2403 12.0312 13.2963 12.0316 13.3548V14.7686C12.0312 14.8273 12.0082 14.8834 11.9677 14.9249C11.9272 14.9664 11.8723 14.9899 11.815 14.9903H9.94107C9.88407 14.9903 9.8294 14.9671 9.7891 14.9259C9.74879 14.8846 9.72615 14.8286 9.72615 14.7703V13.3548C9.72658 13.2966 9.74936 13.2408 9.78957 13.1997C9.82978 13.1585 9.8842 13.1351 9.94107 13.1347H9.93455ZM6.35266 13.1347H8.23315C8.2903 13.1347 8.34513 13.1578 8.3857 13.1991C8.42626 13.2403 8.44926 13.2963 8.44969 13.3548V14.7686C8.44927 14.8273 8.42632 14.8834 8.3858 14.9249C8.34528 14.9664 8.29045 14.9899 8.23315 14.9903H6.36568C6.30881 14.9899 6.2544 14.9666 6.21418 14.9254C6.17397 14.8842 6.15119 14.8285 6.15077 14.7703V13.3548C6.15119 13.2966 6.17397 13.2408 6.21418 13.1997C6.2544 13.1585 6.30881 13.1351 6.36568 13.1347H6.35266ZM9.93455 17.1611H11.815C11.8723 17.1615 11.9272 17.185 11.9677 17.2265C12.0082 17.268 12.0312 17.3241 12.0316 17.3828V18.7949C12.0312 18.8536 12.0082 18.9098 11.9677 18.9512C11.9272 18.9927 11.8723 19.0162 11.815 19.0167H9.94107C9.88392 19.0162 9.82926 18.9927 9.789 18.9511C9.74874 18.9096 9.72615 18.8535 9.72615 18.7949V17.3828C9.72594 17.3538 9.73134 17.325 9.74204 17.2981C9.75275 17.2712 9.76854 17.2467 9.78852 17.2261C9.8085 17.2055 9.83226 17.1891 9.85844 17.178C9.88462 17.1668 9.91271 17.1611 9.94107 17.1611H9.93455ZM8.17128 4.68523C8.17128 4.30844 8.53273 4 8.98535 4C9.43797 4 9.79942 4.3051 9.79942 4.68523V7.67623C9.79942 8.05135 9.43634 8.36145 8.98535 8.36145C8.53436 8.36145 8.17128 8.05468 8.17128 7.67623V4.68523ZM4.8971 10.5405H20.4116V7.0977C20.4119 7.0425 20.4014 6.98781 20.3807 6.93684C20.36 6.88587 20.3295 6.83966 20.2911 6.80093C20.2531 6.76183 20.208 6.73079 20.1582 6.70962C20.1085 6.68845 20.0552 6.67755 20.0013 6.67756H18.5148C18.3952 6.67756 18.2805 6.6289 18.1959 6.54229C18.1113 6.45569 18.0638 6.33822 18.0638 6.21574C18.0638 6.09326 18.1113 5.97579 18.1959 5.88918C18.2805 5.80257 18.3952 5.75392 18.5148 5.75392H20.0013C20.1741 5.7537 20.3453 5.78839 20.505 5.85601C20.6647 5.92364 20.8098 6.02285 20.932 6.14799C21.0542 6.27312 21.1511 6.42172 21.2171 6.58526C21.2832 6.74879 21.3171 6.92407 21.3168 7.10103V12.5695C21.0179 12.464 20.7122 12.3799 20.4018 12.3178V11.4642H4.8971V20.3855C4.89701 20.4406 4.90761 20.4953 4.92829 20.5462C4.94897 20.5972 4.97932 20.6434 5.01759 20.6822C5.0933 20.7597 5.19549 20.8039 5.30251 20.8056H12.6796C12.7636 21.124 12.8691 21.4359 12.9954 21.7392H5.31553C5.14272 21.7395 4.97155 21.7048 4.81185 21.6371C4.65214 21.5695 4.50704 21.4703 4.38483 21.3452C4.26263 21.22 4.16574 21.0714 4.0997 20.9079C4.03367 20.7444 3.99979 20.5691 4 20.3921V7.10103C4.00043 6.74389 4.13917 6.4015 4.38579 6.14897C4.6324 5.89643 4.96677 5.75436 5.31553 5.75392H6.90297C7.02258 5.75392 7.13729 5.80257 7.22187 5.88918C7.30644 5.97579 7.35396 6.09326 7.35396 6.21574C7.35396 6.33822 7.30644 6.45569 7.22187 6.54229C7.13729 6.6289 7.02258 6.67756 6.90297 6.67756H5.31553C5.26163 6.67727 5.20822 6.68804 5.15844 6.70923C5.10867 6.73042 5.06354 6.7616 5.02573 6.80093C4.94948 6.8801 4.90628 6.98652 4.90524 7.0977V10.5422L4.8971 10.5405ZM11.1019 6.67589C10.9823 6.67589 10.8676 6.62724 10.783 6.54063C10.6984 6.45402 10.6509 6.33655 10.6509 6.21407C10.6509 6.09159 10.6984 5.97412 10.783 5.88751C10.8676 5.80091 10.9823 5.75225 11.1019 5.75225H14.1303C14.2499 5.75225 14.3646 5.80091 14.4492 5.88751C14.5337 5.97412 14.5813 6.09159 14.5813 6.21407C14.5813 6.33655 14.5337 6.45402 14.4492 6.54063C14.3646 6.62724 14.2499 6.67589 14.1303 6.67589H11.1019Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             fillRule="evenodd"
//                                             clipRule="evenodd"
//                                             d="M19.0537 13.8566C20.033 13.8579 20.9899 14.1565 21.8035 14.7146C22.6172 15.2727 23.251 16.0652 23.6248 16.9921C23.9987 17.9189 24.0958 18.9384 23.904 19.9218C23.7122 20.9052 23.2399 21.8082 22.547 22.5169C21.8541 23.2255 20.9716 23.7079 20.011 23.903C19.0505 24.0982 18.055 23.9973 17.1503 23.6133C16.2457 23.2292 15.4726 22.5792 14.9286 21.7453C14.3847 20.9114 14.0944 19.9311 14.0944 18.9283C14.0944 18.2617 14.2227 17.6017 14.472 16.9859C14.7213 16.3701 15.0867 15.8107 15.5473 15.3397C16.0079 14.8687 16.5547 14.4952 17.1563 14.2407C17.758 13.9863 18.4027 13.8557 19.0537 13.8566ZM18.5229 20.954H19.5796V21.9126H18.5229V20.954ZM19.5796 20.2871H18.5229C18.4171 18.9716 18.1973 18.1364 18.1973 16.8209C18.2069 16.5947 18.3014 16.3811 18.4611 16.2245C18.6209 16.068 18.8334 15.9806 19.0545 15.9806C19.2756 15.9806 19.4882 16.068 19.6479 16.2245C19.8076 16.3811 19.9021 16.5947 19.9117 16.8209C19.9117 18.1347 19.6887 18.9716 19.5861 20.2871H19.5796Z"
//                                             fill="#FF9A6B"
//                                         />
//                                     </svg>
//                                     <p>Received</p>
//                                     <h6> 0 </h6>
//                                 </div>
//                                 <div className="llt_dash_vehicle_d1">
//                                     <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="25"
//                                         height="20"
//                                         viewBox="0 0 25 20"
//                                         fill="none"
//                                     >
//                                         <path
//                                             fillRule="evenodd"
//                                             clipRule="evenodd"
//                                             d="M4.03088 9.49409C4.16235 9.49409 4.28843 9.54739 4.38139 9.64227C4.47435 9.73714 4.52658 9.86582 4.52658 10C4.52658 10.1342 4.47435 10.2629 4.38139 10.3577C4.28843 10.4526 4.16235 10.5059 4.03088 10.5059H3.48214C3.35067 10.5059 3.22459 10.4526 3.13163 10.3577C3.03867 10.2629 2.98644 10.1342 2.98644 10C2.98644 9.86582 3.03867 9.73714 3.13163 9.64227C3.22459 9.54739 3.35067 9.49409 3.48214 9.49409H4.03088ZM9.32257 15.9832C9.32257 15.849 9.3748 15.7203 9.46776 15.6255C9.56072 15.5306 9.6868 15.4773 9.81827 15.4773C9.94974 15.4773 10.0758 15.5306 10.1688 15.6255C10.2617 15.7203 10.314 15.849 10.314 15.9832V16.5339C10.314 16.6681 10.2617 16.7968 10.1688 16.8916C10.0758 16.9865 9.94974 17.0398 9.81827 17.0398C9.6868 17.0398 9.56072 16.9865 9.46776 16.8916C9.3748 16.7968 9.32257 16.6681 9.32257 16.5339V15.9832ZM9.32257 3.53889C9.32257 3.40472 9.3748 3.27604 9.46776 3.18116C9.56072 3.08628 9.6868 3.03298 9.81827 3.03298C9.94974 3.03298 10.0758 3.08628 10.1688 3.18116C10.2617 3.27604 10.314 3.40472 10.314 3.53889V4.09894C10.314 4.23312 10.2617 4.3618 10.1688 4.45668C10.0758 4.55155 9.94974 4.60485 9.81827 4.60485C9.6868 4.60485 9.56072 4.55155 9.46776 4.45668C9.3748 4.3618 9.32257 4.23312 9.32257 4.09894V3.53889ZM5.90026 4.70006C5.8392 4.58448 5.82474 4.44915 5.85996 4.32285C5.89518 4.19656 5.9773 4.08928 6.08885 4.02384C6.2004 3.9584 6.33256 3.93998 6.45721 3.97248C6.58187 4.00499 6.68917 4.08586 6.75629 4.19788L7.03615 4.67766C7.07058 4.73511 7.09337 4.79903 7.10319 4.86562C7.113 4.93221 7.10965 5.00014 7.09331 5.06539C7.07698 5.13064 7.048 5.19188 7.00809 5.24551C6.96817 5.29914 6.91813 5.34406 6.86093 5.37761C6.80372 5.41117 6.7405 5.43269 6.67501 5.4409C6.60952 5.44911 6.54308 5.44384 6.47961 5.4254C6.41615 5.40697 6.35695 5.37574 6.30551 5.33356C6.25407 5.29138 6.21143 5.23911 6.18012 5.17984L5.9094 4.70006H5.90026ZM12.765 4.26136C12.8321 4.14933 12.9394 4.06846 13.0641 4.03595C13.1887 4.00345 13.3209 4.02187 13.4325 4.08731C13.544 4.15275 13.6261 4.26003 13.6613 4.38632C13.6966 4.51262 13.6821 4.64795 13.621 4.76353L13.3503 5.24331C13.2841 5.35917 13.1755 5.44343 13.0484 5.47757C12.9213 5.5117 12.7862 5.49291 12.6726 5.42533C12.5591 5.35774 12.4766 5.2469 12.4431 5.11719C12.4097 4.98748 12.4281 4.84952 12.4943 4.73366L12.765 4.25389V4.26136ZM3.80224 7.26696C3.68848 7.20061 3.6052 7.09086 3.57073 6.96185C3.53625 6.83284 3.5534 6.69513 3.61841 6.57903C3.68342 6.46292 3.79095 6.37793 3.91736 6.34275C4.04376 6.30756 4.17869 6.32507 4.29245 6.39141L4.76253 6.66957C4.81874 6.70267 4.86801 6.74674 4.90753 6.79927C4.94705 6.8518 4.97605 6.91176 4.99286 6.97572C5.00968 7.03969 5.01399 7.10641 5.00554 7.17208C4.99709 7.23774 4.97605 7.30107 4.94362 7.35843C4.91119 7.4158 4.86801 7.46608 4.81654 7.50642C4.76507 7.54675 4.70632 7.57635 4.64365 7.59351C4.58097 7.61067 4.5156 7.61506 4.45126 7.60644C4.38692 7.59782 4.32488 7.57634 4.26867 7.54325L3.80041 7.26696H3.80224ZM15.3606 6.39141C15.4169 6.35844 15.479 6.33711 15.5434 6.32865C15.6078 6.32018 15.6732 6.32475 15.7359 6.34209C15.7986 6.35942 15.8573 6.38919 15.9087 6.42968C15.9601 6.47017 16.0032 6.52061 16.0355 6.5781C16.0678 6.63558 16.0887 6.69901 16.097 6.76474C16.1053 6.83047 16.1008 6.89722 16.0838 6.96119C16.0669 7.02516 16.0377 7.08508 15.998 7.13755C15.9583 7.19001 15.9089 7.23398 15.8526 7.26696L15.3825 7.54325C15.2693 7.60557 15.1367 7.62033 15.0129 7.58438C14.8892 7.54843 14.7841 7.46462 14.7199 7.35077C14.6558 7.23693 14.6378 7.10204 14.6696 6.97481C14.7015 6.84759 14.7807 6.73807 14.8905 6.66957L15.3606 6.39141ZM4.57596 13.9054C4.46272 13.9677 4.33011 13.9825 4.20637 13.9465C4.08262 13.9106 3.97751 13.8268 3.91339 13.7129C3.84928 13.5991 3.83123 13.4642 3.86307 13.337C3.89492 13.2098 3.97416 13.1002 4.08393 13.0317L4.55401 12.761C4.61031 12.7259 4.67293 12.7026 4.73818 12.6926C4.80343 12.6826 4.86998 12.686 4.93391 12.7027C4.99784 12.7194 5.05785 12.749 5.1104 12.7897C5.16294 12.8304 5.20695 12.8815 5.23983 12.9399C5.27272 12.9983 5.2938 13.0628 5.30184 13.1296C5.30989 13.1965 5.30472 13.2643 5.28666 13.3291C5.26859 13.3938 5.238 13.4542 5.19667 13.5067C5.15534 13.5592 5.10413 13.6028 5.04605 13.6347L4.57596 13.911V13.9054ZM6.85324 15.8525C6.78612 15.9645 6.67881 16.0454 6.55416 16.0779C6.4295 16.1104 6.29734 16.092 6.18579 16.0266C6.07425 15.9611 5.99213 15.8538 5.9569 15.7276C5.92168 15.6013 5.93614 15.4659 5.9972 15.3503L6.26791 14.8706C6.29679 14.807 6.33835 14.7502 6.38993 14.7039C6.44152 14.6576 6.502 14.6228 6.56751 14.6017C6.63303 14.5806 6.70213 14.5737 6.7704 14.5814C6.83867 14.5892 6.90462 14.6113 6.96402 14.6465C7.02343 14.6817 7.07498 14.7292 7.11539 14.7859C7.15581 14.8426 7.18419 14.9073 7.19872 14.9758C7.21325 15.0443 7.21362 15.1152 7.19981 15.1838C7.18599 15.2525 7.15828 15.3175 7.11846 15.3746L6.85324 15.8525ZM9.81827 1C11.577 1.00072 13.2954 1.53758 14.7531 2.54175C16.2109 3.54591 17.3415 4.97159 18 6.63597C17.9488 6.63597 17.8976 6.63597 17.8464 6.63597C17.595 6.63769 17.3464 6.6897 17.1147 6.78905C16.5473 5.44626 15.6345 4.28517 14.473 3.42888C13.3116 2.5726 11.9447 2.05301 10.5174 1.92522C9.09009 1.79742 7.65548 2.06618 6.36568 2.70299C5.07587 3.33981 3.97893 4.32095 3.19114 5.5424C2.40335 6.76386 1.95407 8.18011 1.89093 9.64102C1.82779 11.1019 2.15314 12.5531 2.8325 13.8406C3.51186 15.1281 4.5199 16.204 5.74976 16.9542C6.97962 17.7045 8.38547 18.1011 9.81827 18.1021C10.1509 18.1017 10.4832 18.0805 10.8133 18.0386C10.86 18.3236 10.9668 18.5949 11.1261 18.8339L11.1682 18.8955C10.7215 18.9653 10.2702 19.0002 9.81827 19C8.66024 19 7.51355 18.7672 6.44366 18.3149C5.37378 17.8626 4.40166 17.1997 3.58281 16.364C2.76396 15.5282 2.11441 14.5361 1.67125 13.4442C1.22809 12.3522 1 11.1819 1 10C1 8.8181 1.22809 7.64778 1.67125 6.55585C2.11441 5.46392 2.76396 4.47177 3.58281 3.63604C4.40166 2.80031 5.37378 2.13738 6.44366 1.68508C7.51355 1.23279 8.66024 1 9.81827 1Z"
//                                             fill="black"
//                                             stroke="black"
//                                             strokeWidth="0.2"
//                                         />
//                                         <path
//                                             d="M7.56895 13.1365C7.50824 13.0316 7.48645 12.904 7.50825 12.7811C7.53005 12.6583 7.59369 12.55 7.68553 12.4794L10.0006 10.7428V6.30268C10.0006 6.1782 10.0444 6.05882 10.1225 5.9708C10.2006 5.88278 10.3065 5.83333 10.417 5.83333C10.5274 5.83333 10.6333 5.88278 10.7114 5.9708C10.7895 6.05882 10.8333 6.1782 10.8333 6.30268V10.9962C10.8334 11.0738 10.8168 11.1502 10.7848 11.2188C10.7529 11.2875 10.7067 11.3464 10.6501 11.3905L8.15187 13.2679C8.05672 13.3278 7.94577 13.3474 7.83893 13.3233C7.73209 13.2992 7.63637 13.233 7.56895 13.1365Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M7.56895 13.1365C7.50824 13.0316 7.48645 12.904 7.50825 12.7811C7.53005 12.6583 7.59369 12.55 7.68553 12.4794L10.0006 10.7428V6.30268C10.0006 6.1782 10.0444 6.05882 10.1225 5.9708C10.2006 5.88278 10.3065 5.83333 10.417 5.83333C10.5274 5.83333 10.6333 5.88278 10.7114 5.9708C10.7895 6.05882 10.8333 6.1782 10.8333 6.30268V10.9962C10.8334 11.0738 10.8168 11.1502 10.7848 11.2188C10.7529 11.2875 10.7067 11.3464 10.6501 11.3905L8.15187 13.2679C8.05672 13.3278 7.94577 13.3474 7.83893 13.3233C7.73209 13.2992 7.63637 13.233 7.56895 13.1365Z"
//                                             stroke="black"
//                                         />
//                                         <path
//                                             d="M19.1657 8.69166C18.6386 7.76945 17.3501 7.76945 16.8229 8.69166L12.1959 16.8482C11.6492 17.7909 12.313 19 13.3673 19H22.6409C23.6952 19 24.3394 17.7909 23.8123 16.8482L19.1657 8.69166ZM17.9358 10.5361C18.3653 10.4951 18.7362 10.823 18.7557 11.2739C18.7557 11.3149 18.7557 11.3763 18.7557 11.4173L18.5019 14.4709C18.4824 14.7578 18.2286 14.9832 17.9553 14.9627C17.7015 14.9422 17.5062 14.7373 17.4867 14.4709L17.2329 11.4173C17.1939 10.9665 17.5062 10.5771 17.9358 10.5361ZM17.9943 17.34C17.5453 17.34 17.1743 16.9506 17.1743 16.4793C17.1743 16.0079 17.5453 15.6185 17.9943 15.6185C18.4434 15.6185 18.8143 16.0079 18.8143 16.4793C18.8143 16.9506 18.4434 17.34 17.9943 17.34Z"
//                                             fill="#F64040"
//                                         />
//                                     </svg>
//                                     <p>Expired</p>
//                                     <h6> 0 </h6>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="col-12 col-md-6 col-lg-6 col-xl-4">
//                     <div className="llt_dash_payment">
//                         <h5>Payment Approval</h5>
//                         <div className="llt_dash_payment_bx">
//                             <div className="llt_dash_payment_bx_1">
//                                 <div>
//                                     <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="24"
//                                         height="24"
//                                         viewBox="0 0 24 24"
//                                         fill="none"
//                                     >
//                                         <g clipPath="url(#clip0_7552_9165)">
//                                             <path
//                                                 d="M12.1426 23.3857C13.9525 23.3895 15.7358 22.9514 17.3378 22.1094C17.4407 22.0694 17.5342 22.0084 17.6123 21.9303C17.6918 21.8508 17.7537 21.7552 17.7936 21.65C17.8336 21.5448 17.8508 21.4323 17.8441 21.32C17.8375 21.2076 17.807 21.098 17.7549 20.9982C17.7028 20.8985 17.6301 20.8109 17.5417 20.7413C17.4532 20.6717 17.351 20.6217 17.2418 20.5944C17.1326 20.5672 17.0189 20.5634 16.9081 20.5833C16.7994 20.6029 16.6959 20.6448 16.6043 20.7065C14.7383 21.6795 12.6053 22.0158 10.5303 21.6641C8.45338 21.3121 6.54873 20.2901 5.10703 18.7543C3.66533 17.2184 2.76578 15.253 2.54568 13.1581C2.32559 11.0631 2.79703 8.95365 3.88806 7.1517C4.97909 5.34976 6.62977 3.95431 8.58815 3.17836C10.5465 2.4024 12.705 2.28855 14.7341 2.8542C16.7633 3.41985 18.5516 4.63392 19.8261 6.3111C21.1005 7.98808 21.7912 10.0359 21.7929 12.1422C21.7822 12.8572 21.6944 13.5689 21.5308 14.265L21.5305 14.2664C21.5076 14.3707 21.5054 14.4784 21.5241 14.5836C21.5428 14.6887 21.5821 14.7891 21.6396 14.879C21.6971 14.969 21.7718 15.0468 21.8593 15.1079C21.9469 15.169 22.0457 15.2122 22.1499 15.2352C22.2542 15.2581 22.362 15.2603 22.4671 15.2416C22.5722 15.2229 22.6727 15.1836 22.7626 15.1261C22.8526 15.0686 22.9303 14.9939 22.9914 14.9064C23.0525 14.8188 23.0958 14.7201 23.1187 14.6158L23.1189 14.6151C23.2916 13.8024 23.381 12.9742 23.3857 12.1434V12.1429C23.3857 9.91923 22.7263 7.74554 21.4909 5.89666C20.2556 4.04779 18.4997 2.60676 16.4453 1.75582C14.3909 0.904871 12.1304 0.682225 9.94948 1.11603C7.76859 1.54984 5.7653 2.62062 4.19296 4.19296C2.62062 5.7653 1.54984 7.76859 1.11603 9.94949C0.682225 12.1304 0.904871 14.3909 1.75582 16.4453C2.60676 18.4997 4.04779 20.2556 5.89666 21.4909C7.74548 22.7263 9.9191 23.3857 12.1426 23.3857ZM12.1426 23.3857L12.1429 23.2857V23.3857C12.1428 23.3857 12.1427 23.3857 12.1426 23.3857Z"
//                                                 fill="black"
//                                                 stroke="black"
//                                                 strokeWidth="0.2"
//                                             />
//                                             <path
//                                                 d="M6.99198 16.0696L6.99164 16.0698L12.5357 12.8393H12.6357V12.8392V5.87501C12.6357 5.66378 12.5518 5.46121 12.4025 5.31185C12.2531 5.16249 12.0505 5.07858 11.8393 5.07858C11.6281 5.07858 11.4255 5.16249 11.2762 5.31185C11.1268 5.46121 11.0429 5.66378 11.0429 5.87501V12.4096L7.21534 14.9567L7.21443 14.9574C7.03919 15.0768 6.91775 15.2601 6.87616 15.4681C6.83457 15.676 6.87615 15.892 6.99198 16.0696Z"
//                                                 fill="black"
//                                                 stroke="black"
//                                                 strokeWidth="0.2"
//                                             />
//                                             <path
//                                                 d="M18.5 24.5C21.8137 24.5 24.5 21.8137 24.5 18.5C24.5 15.1863 21.8137 12.5 18.5 12.5C15.1863 12.5 12.5 15.1863 12.5 18.5C12.5 21.8137 15.1863 24.5 18.5 24.5Z"
//                                                 fill="#FF9900"
//                                                 stroke="white"
//                                             />
//                                             <path
//                                                 d="M18.5 19.5C18.6326 19.5 18.7598 19.4579 18.8536 19.3828C18.9473 19.3078 19 19.2061 19 19.1V15.9C19 15.7939 18.9473 15.6922 18.8536 15.6172C18.7598 15.5421 18.6326 15.5 18.5 15.5C18.3674 15.5 18.2402 15.5421 18.1464 15.6172C18.0527 15.6922 18 15.7939 18 15.9V19.1C18 19.2061 18.0527 19.3078 18.1464 19.3828C18.2402 19.4579 18.3674 19.5 18.5 19.5Z"
//                                                 fill="white"
//                                                 stroke="white"
//                                                 strokeWidth="0.3"
//                                             />
//                                             <path
//                                                 d="M18.5 21.5C18.2239 21.5 18 21.2761 18 21C18 20.7239 18.2239 20.5 18.5 20.5C18.7761 20.5 19 20.7239 19 21C19 21.2761 18.7761 21.5 18.5 21.5Z"
//                                                 fill="white"
//                                                 stroke="white"
//                                                 strokeWidth="0.3"
//                                             />
//                                         </g>
//                                         <defs>
//                                             <clipPath id="clip0_7552_9165">
//                                                 <rect width="24" height="24" fill="white" />
//                                             </clipPath>
//                                         </defs>
//                                     </svg>
//                                 </div>
//                                 <h6>{dashboardData?.payment_approval_status?.pending}</h6>
//                                 <p>Pending</p>
//                             </div>
//                             <div className="llt_dash_payment_bx_1">
//                                 <div>
//                                     <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="24"
//                                         height="24"
//                                         viewBox="0 0 24 24"
//                                         fill="none"
//                                     >
//                                         <path
//                                             d="M11.1617 18.7293H1.96972C0.883551 18.7293 0 17.8117 0 16.6836V3.04569C0 1.91763 0.883551 1 1.96972 1H20.7915C21.8777 1 22.7612 1.91763 22.7612 3.04569V13.6151C22.7612 13.9918 22.4673 14.297 22.1046 14.297C21.7419 14.297 21.4481 13.9918 21.4481 13.6151V3.04569C21.4481 2.66967 21.1535 2.36379 20.7915 2.36379H1.96972C1.60766 2.36379 1.31315 2.66967 1.31315 3.04569V16.6836C1.31315 17.0596 1.60766 17.3655 1.96972 17.3655H11.1617C11.5244 17.3655 11.8183 17.6707 11.8183 18.0474C11.8183 18.4241 11.5244 18.7293 11.1617 18.7293Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M22.1046 9.18273H0.656573C0.293878 9.18273 0 8.87752 0 8.50084C0 8.12415 0.293878 7.81894 0.656573 7.81894H22.1046C22.4673 7.81894 22.7612 8.12415 22.7612 8.50084C22.7612 8.87752 22.4673 9.18273 22.1046 9.18273Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M22.1046 6.00059H0.656573C0.293878 6.00059 0 5.69538 0 5.3187C0 4.94201 0.293878 4.6368 0.656573 4.6368H22.1046C22.4673 4.6368 22.7612 4.94201 22.7612 5.3187C22.7612 5.69538 22.4673 6.00059 22.1046 6.00059Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M7.66004 12.365H3.28289C2.92019 12.365 2.62631 12.0597 2.62631 11.6831C2.62631 11.3064 2.92019 11.0012 3.28289 11.0012H7.66004C8.02274 11.0012 8.31661 11.3064 8.31661 11.6831C8.31661 12.0597 8.02274 12.365 7.66004 12.365Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M5.03375 14.6379H3.28289C2.92019 14.6379 2.62631 14.3327 2.62631 13.956C2.62631 13.5793 2.92019 13.2741 3.28289 13.2741H5.03375C5.39644 13.2741 5.69032 13.5793 5.69032 13.956C5.69032 14.3327 5.39644 14.6379 5.03375 14.6379Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M17.4343 12C14.4378 12 12 14.4874 12 17.5448C12 20.6022 14.4378 23.0897 17.4343 23.0897C20.4307 23.0897 22.8685 20.6022 22.8685 17.5448C22.8685 14.4874 20.4307 12 17.4343 12ZM19.8738 19.1629C20.1097 19.4033 20.1097 19.7936 19.8738 20.0341C19.7559 20.1544 19.6014 20.2146 19.4469 20.2146C19.2924 20.2146 19.138 20.1544 19.02 20.0341L17.4343 18.416L15.8485 20.0341C15.7305 20.1544 15.5761 20.2146 15.4216 20.2146C15.2671 20.2146 15.1126 20.1544 14.9947 20.0341C14.7588 19.7936 14.7588 19.4033 14.9947 19.1629L16.5804 17.5448L14.9947 15.9268C14.7588 15.6863 14.7588 15.2961 14.9947 15.0556C15.2305 14.8149 15.6126 14.8149 15.8485 15.0556L17.4342 16.6736L19.02 15.0556C19.2559 14.8149 19.638 14.8149 19.8738 15.0556C20.1097 15.2961 20.1097 15.6863 19.8738 15.9268L18.2881 17.5448L19.8738 19.1629Z"
//                                             fill="#F64040"
//                                         />
//                                     </svg>
//                                 </div>
//                                 <h6>{dashboardData?.payment_approval_status?.rejected}</h6>
//                                 <p>Rejected</p>
//                             </div>
//                             <div className="llt_dash_payment_bx_1">
//                                 <div>
//                                     <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="24"
//                                         height="24"
//                                         viewBox="0 0 24 24"
//                                         fill="none"
//                                     >
//                                         <path
//                                             d="M11.1617 18.7293H1.96972C0.883551 18.7293 0 17.8117 0 16.6836V3.04569C0 1.91763 0.883551 1 1.96972 1H20.7915C21.8777 1 22.7612 1.91763 22.7612 3.04569V13.6151C22.7612 13.9918 22.4673 14.297 22.1046 14.297C21.7419 14.297 21.4481 13.9918 21.4481 13.6151V3.04569C21.4481 2.66967 21.1535 2.36379 20.7915 2.36379H1.96972C1.60766 2.36379 1.31315 2.66967 1.31315 3.04569V16.6836C1.31315 17.0596 1.60766 17.3655 1.96972 17.3655H11.1617C11.5244 17.3655 11.8183 17.6707 11.8183 18.0474C11.8183 18.4241 11.5244 18.7293 11.1617 18.7293Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M22.1046 9.18273H0.656573C0.293878 9.18273 0 8.87752 0 8.50084C0 8.12415 0.293878 7.81894 0.656573 7.81894H22.1046C22.4673 7.81894 22.7612 8.12415 22.7612 8.50084C22.7612 8.87752 22.4673 9.18273 22.1046 9.18273Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M22.1046 6.00059H0.656573C0.293878 6.00059 0 5.69538 0 5.3187C0 4.94201 0.293878 4.6368 0.656573 4.6368H22.1046C22.4673 4.6368 22.7612 4.94201 22.7612 5.3187C22.7612 5.69538 22.4673 6.00059 22.1046 6.00059Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M7.66003 12.365H3.28287C2.92017 12.365 2.6263 12.0597 2.6263 11.6831C2.6263 11.3064 2.92017 11.0012 3.28287 11.0012H7.66003C8.02272 11.0012 8.3166 11.3064 8.3166 11.6831C8.3166 12.0597 8.02272 12.365 7.66003 12.365Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M5.03373 14.6379H3.28287C2.92017 14.6379 2.6263 14.3327 2.6263 13.956C2.6263 13.5793 2.92017 13.2741 3.28287 13.2741H5.03373C5.39643 13.2741 5.69031 13.5793 5.69031 13.956C5.69031 14.3327 5.39643 14.6379 5.03373 14.6379Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M17.435 12C14.438 12 12 14.4382 12 17.435C12 20.4318 14.438 22.87 17.435 22.87C20.432 22.87 22.87 20.4318 22.87 17.435C22.87 14.4382 20.432 12 17.435 12ZM20.3782 16.2514L17.1574 19.4725C17.0442 19.5858 16.8905 19.6495 16.7305 19.6495C16.5704 19.6495 16.4167 19.5858 16.3035 19.4725L14.4918 17.6609C14.2559 17.4252 14.2559 17.0426 14.4918 16.8069C14.7277 16.571 15.1099 16.571 15.3458 16.8069L16.7305 18.1914L19.5242 15.3975C19.7601 15.1616 20.1423 15.1616 20.3782 15.3975C20.6141 15.6332 20.6141 16.0155 20.3782 16.2514Z"
//                                             fill="#00A63E"
//                                         />
//                                     </svg>
//                                 </div>
//                                 <h6>{dashboardData?.payment_approval_status?.approved}</h6>
//                                 <p>Approved</p>
//                             </div>
//                             <div className="llt_dash_payment_bx_1">
//                                 <div>
//                                     <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="24"
//                                         height="24"
//                                         viewBox="0 0 24 24"
//                                         fill="none"
//                                     >
//                                         <path
//                                             d="M11.1617 18.7293H1.96972C0.883551 18.7293 0 17.8117 0 16.6836V3.04569C0 1.91763 0.883551 1 1.96972 1H20.7915C21.8777 1 22.7612 1.91763 22.7612 3.04569V13.6151C22.7612 13.9918 22.4673 14.297 22.1046 14.297C21.7419 14.297 21.4481 13.9918 21.4481 13.6151V3.04569C21.4481 2.66967 21.1535 2.36379 20.7915 2.36379H1.96972C1.60766 2.36379 1.31315 2.66967 1.31315 3.04569V16.6836C1.31315 17.0596 1.60766 17.3655 1.96972 17.3655H11.1617C11.5244 17.3655 11.8183 17.6707 11.8183 18.0474C11.8183 18.4241 11.5244 18.7293 11.1617 18.7293Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M22.1046 9.18273H0.656573C0.293878 9.18273 0 8.87752 0 8.50084C0 8.12415 0.293878 7.81894 0.656573 7.81894H22.1046C22.4673 7.81894 22.7612 8.12415 22.7612 8.50084C22.7612 8.87752 22.4673 9.18273 22.1046 9.18273Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M22.1046 6.0006H0.656573C0.293878 6.0006 0 5.69538 0 5.3187C0 4.94201 0.293878 4.6368 0.656573 4.6368H22.1046C22.4673 4.6368 22.7612 4.94201 22.7612 5.3187C22.7612 5.69538 22.4673 6.0006 22.1046 6.0006Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M7.66004 12.365H3.28289C2.92019 12.365 2.62631 12.0597 2.62631 11.6831C2.62631 11.3064 2.92019 11.0012 3.28289 11.0012H7.66004C8.02274 11.0012 8.31661 11.3064 8.31661 11.6831C8.31661 12.0597 8.02274 12.365 7.66004 12.365Z"
//                                             fill="black"
//                                         />
//                                         <path
//                                             d="M5.03375 14.6379H3.28289C2.92019 14.6379 2.62631 14.3327 2.62631 13.956C2.62631 13.5793 2.92019 13.2741 3.28289 13.2741H5.03375C5.39644 13.2741 5.69032 13.5793 5.69032 13.956C5.69032 14.3327 5.39644 14.6379 5.03375 14.6379Z"
//                                             fill="black"
//                                         />
//                                         <circle
//                                             cx="17.435"
//                                             cy="17.435"
//                                             r="5.435"
//                                             fill="#FFCD00"
//                                         />
//                                         <path
//                                             d="M19.7495 14.636L19.5333 13.8046C19.5179 13.729 19.4253 13.6685 19.3481 13.6988C19.2709 13.7139 19.2092 13.8046 19.24 13.8802L19.3635 14.3488C18.1902 13.6383 16.6773 13.6232 15.4886 14.3639C15.4114 14.4092 15.396 14.4999 15.4423 14.5755C15.4886 14.6511 15.5812 14.6662 15.6584 14.6209C16.7391 13.9406 18.1285 13.9406 19.2092 14.6209H19.2246L18.7306 14.7418C18.6379 14.7872 18.5916 14.8627 18.6071 14.9383C18.6225 15.0139 18.7151 15.0744 18.7923 15.0441L19.6414 14.8325C19.8021 14.8014 19.7495 14.636 19.7495 14.636Z"
//                                             fill="white"
//                                             stroke="white"
//                                             strokeWidth="0.3"
//                                         />
//                                         <path
//                                             d="M14.8094 15.286L13.9449 15.1953C13.8522 15.1802 13.7905 15.2406 13.775 15.3313C13.7596 15.4069 13.8214 15.4825 13.914 15.4976L14.3308 15.543C13.9912 16.1023 13.8059 16.7372 13.8059 17.3872C13.8059 18.0674 14.0066 18.7174 14.3617 19.2919C14.408 19.3674 14.5006 19.3826 14.5778 19.3372C14.655 19.2919 14.6704 19.2012 14.6241 19.1256C14.2845 18.6116 14.1147 18.007 14.1147 17.3872C14.1147 16.7674 14.2845 16.1628 14.6241 15.6488V15.6337L14.5624 16.2383C14.5469 16.3139 14.6087 16.3895 14.6859 16.4046H14.7013C14.7785 16.4046 14.8403 16.3441 14.8557 16.2686L14.9483 15.4523C14.9611 15.2874 14.8094 15.286 14.8094 15.286Z"
//                                             fill="white"
//                                             stroke="white"
//                                             strokeWidth="0.3"
//                                         />
//                                         <path
//                                             d="M20.1663 18.3698C20.0891 18.3698 20.0119 18.4151 19.9965 18.5058L19.9039 19.3674C19.8884 19.443 19.9502 19.5186 20.0428 19.5337L20.9074 19.6244C21 19.6244 21.0617 19.564 21.0772 19.4884C21.0926 19.4128 21.0309 19.3372 20.9382 19.3221L20.4905 19.2767C20.8456 18.7174 21.0463 18.0674 21.0463 17.4023C21.0463 16.7221 20.8456 16.0721 20.4905 15.4976C20.4442 15.422 20.3516 15.4069 20.2744 15.4523C20.1972 15.4976 20.1818 15.5883 20.2281 15.6639C20.5677 16.1779 20.7375 16.7825 20.7375 17.4023C20.7375 18.007 20.5677 18.5965 20.2435 19.1105L20.3053 18.5512C20.3207 18.4453 20.259 18.3698 20.1663 18.3698Z"
//                                             fill="white"
//                                             stroke="white"
//                                             strokeWidth="0.3"
//                                         />
//                                         <path
//                                             d="M15.2262 20.0023L15.288 20.864C15.288 20.9395 15.3651 21 15.4423 21H15.4578C15.5504 21 15.6122 20.9244 15.5967 20.8337L15.5658 20.4256C16.7391 21.1209 18.2212 21.1058 19.379 20.3802C19.4562 20.3349 19.4717 20.2442 19.4253 20.1686C19.379 20.093 19.2864 20.0779 19.2092 20.1232C18.1285 20.8035 16.7391 20.8035 15.6585 20.1232H15.643L16.2606 20.0779C16.3532 20.0779 16.4149 20.0023 16.3995 19.9116C16.3841 19.8209 16.3223 19.7605 16.2297 19.7756L15.3497 19.836C15.3497 19.836 15.2176 19.8548 15.2262 20.0023Z"
//                                             fill="white"
//                                             stroke="white"
//                                             strokeWidth="0.3"
//                                         />
//                                     </svg>
//                                 </div>
//                                 <h6>{dashboardData?.payment_approval_status?.hold}</h6>
//                                 <p>Hold</p>
//                             </div>
//                             <div className="llt_dash_payment_bx_1">
//                                 <div>
//                                     <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="24"
//                                         height="24"
//                                         viewBox="0 0 24 24"
//                                         fill="none"
//                                     >
//                                         <path
//                                             d="M12 22.9C5.98984 22.9 1.1 18.0099 1.1 11.9998C1.1 5.98975 5.98983 1.1 12 1.1C18.0102 1.1 22.9 5.98975 22.9 11.9998C22.9 18.0099 18.0102 22.9 12 22.9ZM12 21.0999C17.018 21.0999 21.1002 17.0177 21.1002 11.9998C21.1002 6.98231 17.018 2.90014 12 2.90014C6.98204 2.90014 2.89979 6.98231 2.89979 11.9998C2.89979 17.0177 6.98204 21.0999 12 21.0999Z"
//                                             fill="black"
//                                             stroke="white"
//                                             strokeWidth="0.2"
//                                         />
//                                         <path
//                                             d="M11.1733 8.0698L11.1027 8.09149C10.0209 8.42369 9.25843 9.31306 9.25843 10.3415C9.25843 11.645 10.488 12.7296 12.0306 12.7296C12.5997 12.7296 13.0879 13.1334 13.0879 13.6589C13.0879 14.1843 12.5997 14.5881 12.0306 14.5881C11.5858 14.5881 11.1197 14.3471 10.7157 13.9304C10.4113 13.6169 9.86354 13.5741 9.4975 13.8405L11.1733 8.0698ZM11.1733 8.0698V7.9959M11.1733 8.0698V7.9959M11.1733 7.9959V7.02404C11.1733 6.63401 11.5433 6.29444 12.0306 6.29444C12.5179 6.29444 12.8879 6.63401 12.8879 7.02404V7.99007V8.06538L12.9603 8.08618C13.3853 8.20828 13.8589 8.43234 14.3335 8.83019C14.667 9.10998 14.6751 9.56356 14.3532 9.8518C14.0228 10.1474 13.4725 10.1556 13.1303 9.86881C12.7797 9.57481 12.3997 9.41186 12.0306 9.41186C11.4615 9.41186 10.9733 9.81603 10.9733 10.3415C10.9733 10.8669 11.4615 11.2707 12.0306 11.2707C13.5732 11.2707 14.8028 12.355 14.8028 13.6589C14.8028 14.6869 14.0403 15.5763 12.9585 15.9088L12.8879 15.9305V16.0044V16.9763C12.8879 17.3663 12.5179 17.7056 12.0306 17.7056C11.5433 17.7056 11.1733 17.3663 11.1733 16.9763V16.0083V15.9332L11.1012 15.9123C10.4814 15.7321 9.89428 15.3744 9.39366 14.8586L9.39365 14.8586M11.1733 7.9959L9.39365 14.8586M9.39365 14.8586C9.09763 14.5537 9.13952 14.1013 9.49746 13.8405L9.39365 14.8586Z"
//                                             fill="black"
//                                             stroke="white"
//                                             strokeWidth="0.2"
//                                         />
//                                         <circle
//                                             cx="18.565"
//                                             cy="5.565"
//                                             r="4.815"
//                                             fill="white"
//                                             stroke="white"
//                                             strokeWidth="0.5"
//                                         />
//                                         <path
//                                             d="M18.565 1C16.0477 1 14 3.04788 14 5.565C14 8.08212 16.0477 10.13 18.565 10.13C21.0823 10.13 23.13 8.08212 23.13 5.565C23.13 3.04788 21.0823 1 18.565 1ZM21.037 4.57086L18.3319 7.27638C18.2368 7.37149 18.1076 7.42498 17.9732 7.42498C17.8388 7.42498 17.7097 7.37149 17.6146 7.27638L16.093 5.75471C15.8948 5.55675 15.8948 5.23544 16.093 5.03747C16.2911 4.83934 16.6121 4.83934 16.8102 5.03747L17.9732 6.20035L20.3198 3.85362C20.5179 3.65549 20.8389 3.65549 21.037 3.85362C21.2352 4.05159 21.2352 4.37273 21.037 4.57086Z"
//                                             fill="#00A63E"
//                                         />
//                                     </svg>
//                                 </div>
//                                 <h6>{dashboardData?.payment_approval_status?.completed}</h6>
//                                 <p>Completed</p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="col-12 col-md-6 col-lg-6 col-xl-4">
//                     <div className="llt_dash_payment">
//                         <h5> EWay Bill Status </h5>
//                         <div className="llt_dash_eway_bx">

//                             <div className="llt_dash_eway_bx_1 llt_dasheway_bill_1 _avPointer" onClick={() => ewayBillApplyFilter(2)}>
//                                 <h6>{dashboardData?.lr_status?.active_eway > 0 ? dashboardData?.lr_status?.active_eway : 0}</h6>
//                                 <p> Active <br /> Eway </p>
//                             </div>

//                             <div className="llt_dash_eway_bx_1 llt_dasheway_bill_2 _avPointer" onClick={() => ewayBillApplyFilter(1)}>
//                                 <h6>{dashboardData?.lr_status?.without_eway > 0 ? dashboardData?.lr_status?.without_eway : 0}</h6>
//                                 <p> Without Eway </p>
//                             </div>

//                             <div className="llt_dash_eway_bx_1 llt_dasheway_bill_3 _avPointer" onClick={() => ewayBillApplyFilter(4)}>
//                                 <h6>{dashboardData?.lr_status?.expiring_today > 0 ? dashboardData?.lr_status?.expiring_today : 0}</h6>
//                                 <p> Expiring Today </p>
//                             </div>

//                             <div className="llt_dash_eway_bx_1 llt_dasheway_bill_4 _avPointer" onClick={() => ewayBillApplyFilter(5)}>
//                                 <h6>{dashboardData?.lr_status?.expired > 0 ? dashboardData?.lr_status?.expired : 0}</h6>
//                                 <p> Expired </p>
//                             </div>

//                             {/* <div className="llt_dash_eway_bx_1 llt_dasheway_bill_5">
//                                 <h6>{dashboardData?.lr_status?.not_found > 0 ? dashboardData?.lr_status?.not_found : 0}</h6>
//                                 <p>Not Found</p>
//                             </div> */}
//                         </div>
//                     </div>
//                 </div>
//                 <div className="col-12 col-md-6 col-lg-6 col-xl-4">
//                     <div className="llt_dash_payment">
//                         <h5>Bank Account</h5>
//                         <div className="llt_dash_Account_bx">
//                             {
//                                 dashboardData?.accounting_list?.length > 0 ?
//                                     dashboardData?.accounting_list?.map((el, index) => {
//                                         return (
//                                             <>
//                                                 <div className="llt_dash_Account_bx_1">
//                                                     <p>{el?.name || ''}</p>
//                                                     <p style={{ color: el?.balance === 0 ? 'blue' : (el?.balance > 0 ? 'green' : 'red') }}> {el?.balance || 0} </p>
//                                                 </div>
//                                             </>
//                                         )
//                                     }) :
//                                     <>
//                                         <div className="llt_dash_Account_bx_1">
//                                             <div className="NoPreviewAvl">No Preview Available</div>
//                                         </div> </>
//                             }

//                         </div>
//                     </div>
//                 </div>

//             </div>

//         </div >
//     )
// }

// export default MainDashboard

import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { Images } from "constants";
import { dashboardCount } from '_services/dashboardService/dashboardService';
import toast from 'react-hot-toast';
import StorageService from 'utils/StorageServices/StorageServices';
import { UserContext } from 'context';
import { CityDropdownForTrip, CommonDateRange, CustomSelect, PieCharts } from 'components';
import moment from 'moment';
import { getBranchDropdownListData, getBranchListApi } from '_services/dropdownServices/dropdownService';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { updateInputValue } from 'features/lrFilterServices/lrFilterSlice';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { updateEwayBillFilters } from 'features/ewayBillFilterServices/ewayBillFilterSlice';
import { IoArrowForwardOutline } from 'react-icons/io5'
import { StorageServices } from 'utils';
import { paymentVerifyApi } from '_services';
import { getUsablityList } from '_services/walletService/walletService';
import { SubscriptionWarnningModal } from 'modals';
import '../Dashboard/maindash.css'
import { BsExclamationCircle } from 'react-icons/bs';
import { createPermissionMap } from 'helper/permissions';
import { hasPermission } from 'utils/permissionHelper';
import { utils } from 'helper';


const MainDashboard = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const getFiltersValues = useSelector((state) => state.lrFilter)?.filters;
    const getEwayBillFilters = useSelector((state) => state.ewayBillFilter)?.filters;
    const { masterData, userData, dashboardFilterClear,
        setDashboardFilterClear, setWarningDetails,
        warningDetails, showWarnning, setShowWarnning, setTRipFilter, setNoAccessISOpen, allMenu } = useContext(UserContext)
    const urlParams = new URLSearchParams(window.location.search);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showPending, setShowPending] = useState(false);
    const [showFailure, setShowFailure] = useState(false);

    const [selectedRange, setSelectedRange] = useState({
        startDate: '',
        endDate: '',
    });
    const [dashboardFilter, setDashboardFilter] = useState({
        company_id: StorageService.getCompanyId(),
        branch_id: {},
        consignor_id: '',
        start_date: '',
        end_date: '',
    })
    const [dashboardData, setDashBoardData] = useState({});
    const [dropdownBranchList, setDropdownBranchList] = useState([]);
    const [chartData, setChartData] = useState([]);
    const conmanyId = StorageService.getCompanyId();
    const globleFirmId = StorageService.getFirmId();
    const orderId = Array.from(urlParams.keys())[0];
    const remainingDays = utils?.calculateRemainingDays(warningDetails.web_end_date);
    const noWebAccess = (() => {
        const web_access = warningDetails?.subscription_data?.web_access;

        if (!web_access) return true; // web_access hi nahi hai

        const startDate = new Date(warningDetails?.subscription_start_date);
        const webEndDate = new Date(startDate);
        webEndDate.setDate(webEndDate.getDate() + web_access);

        // ✅ Expiry us din ki raat 12 baje (23:59:59) hogi
        webEndDate.setHours(23, 59, 59, 999);

        const today = new Date();
        const webRemainingDays = Math.ceil(
            (webEndDate - today) / (1000 * 60 * 60 * 24)
        );

        return webRemainingDays <= 0; // true = no access, false = access hai
    })();

    useDocumentTitle("Dashboard | T360");

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const firstKey = Array.from(urlParams.keys())[0];

        if (firstKey && firstKey.startsWith("order_")) {
            paymentVerifyHandle(firstKey);
        } else {
            return;
        }
    }, [location.search]);

    const getMainDashboard = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                branch_id: dashboardFilter?.branch_id?.value ? dashboardFilter?.branch_id?.value : '',
                consignor_id: dashboardFilter?.consignor_id?.value ? dashboardFilter?.consignor_id?.value : '',
                start_date: selectedRange?.startDate ? moment(selectedRange?.startDate)?.format("YYYY-MM-DD") : getFiltersValues?.start_date,
                end_date: selectedRange?.endDate ? moment(selectedRange?.endDate)?.format("YYYY-MM-DD") : getFiltersValues?.end_date,
                firm_id: getFiltersValues?.branch_id?.firm_id?._id ? getFiltersValues?.branch_id?.firm_id?._id : StorageService.getFirmId(),
            }
            const res = await dashboardCount(object);
            if (res?.responseCode === 200) {
                setDashBoardData(res?.data)
                getDataForChart(res?.data?.trip_status)
            } else {
                toast.error(`${res?.responseMessage}`);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    useEffect(() => {
        if (conmanyId != "undefined" && conmanyId) {
            getMainDashboard();
        }
    }, [dashboardFilter, selectedRange, conmanyId, globleFirmId])

    const getSubscriptionList = useCallback(async () => {
        try {
            const object = { company_id: StorageService.getCompanyId() };
            const res = await getUsablityList(object);

            if (res?.responseCode === 200 && res?.data?.company) {

                setWarningDetails(res.data.company);
                const days = calculateRemainingDays(res?.data?.company.web_end_date)
                if (days == 0) {
                    setShowWarnning(true)
                }
            }
        } catch (error) {
            toast.error("Failed to fetch subscription details!");
        }
    }, []);

    const calculateRemainingDays = useCallback((endDate) => {
        if (!endDate) return 0;

        const today = new Date();
        const end = new Date(endDate);
        const diffDays = Math.ceil((end - today) / (1000 * 60 * 60 * 24));
        return diffDays >= 0 ? diffDays : 0;
    }, []);

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...dashboardFilter, [name]: item };
        setDashboardFilter(stateObj);
        const obj = {
            ...getFiltersValues,
            branch_id: item,
            // start_date: selectedRange?.startDate ? moment(selectedRange?.startDate)?.format("YYYY-MM-DD") : '',
            // end_date: selectedRange?.endDate ? moment(selectedRange?.endDate)?.format("YYYY-MM-DD") : '',
            start_date: selectedRange?.startDate,
            end_date: selectedRange?.endDate,
            lr_pagination: 1
        }
        dispatch(updateInputValue(obj))
        if (name == "branch_id") {
            setTRipFilter((pre) => ({ ...pre, branch_id: item.value, branch_name: item?.label }))
        }
    };

    const getDataForChart = (data) => {
        const trip_status = data
        const selectedStatuses = ["at_party", "in_transit", "delivered", "cancelled"];

        const filteredTripStatusArray = selectedStatuses?.map(status => ({
            name: status,
            value: trip_status[status]
        }));
        setChartData(filteredTripStatusArray)
    }

    // const getDropdownDataBranchList = async () => {
    //     try {
    //         let object = {
    //             company_id: StorageService.getCompanyId(),
    //             firm_id: StorageService.getFirmId(),
    //             limit: 100,
    //             offset: 1,
    //             search: "",
    //         };
    //         const res = await getBranchDropdownListData(object);
    //         if (res?.responseCode == 200) {
    //             setDropdownBranchList([{ branch: "All", _id: "" }, ...res?.data?.branch_list]);
    //         }
    //     } catch (error) {
    //         // throw error;
    //     }
    // };

    useEffect(() => {
        if (conmanyId != "undefined") {
            getSubscriptionList()
            // getDropdownDataBranchList();
        }

    }, [conmanyId])

    const handleApply = (newRange) => {
        setSelectedRange(newRange);
        const obj = {
            ...getFiltersValues,
            start_date: newRange?.startDate,
            end_date: newRange?.endDate,
            lr_status: 0,
            lr_pagination: 1
        }
        dispatch(updateInputValue(obj))
        setTRipFilter((pre) => ({
            ...pre, start_date: newRange?.startDate,
            end_date: newRange?.endDate,
        }))
    };

    const statusWithNavigate = (value, is_action) => {

        // if (!warningDetails?.subscription_data?.web_access) {
        //     setNoAccessISOpen(true)
        //     return;
        // }

        if (noWebAccess) {
            setNoAccessISOpen(true)
            return;
        }
        if (remainingDays <= 0) {
            setShowWarnning(true);
            return;
        }
        const hasLinkPermission = hasPermission("/lr/addlr", allMenu, 'web', 'link');

        if (!hasLinkPermission) {
            toast.error("You don't have permission to access this page");
            return;
        }

        navigate('/lr/addlr');
        if (!is_action) {
            setSelectedRange({
                startDate: '',
                endDate: '',
            })
            const obj = {
                ...getFiltersValues,
                start_date: '',
                end_date: '',
                lr_status: value,
                lr_pagination: 1
            }
            dispatch(updateInputValue(obj))
        } else {
            const obj = {
                ...getFiltersValues,
                lr_status: value,
                lr_pagination: 1
            }
            dispatch(updateInputValue(obj))
        }
    }

    const handleApplyFilter = (object) => {
        if (noWebAccess) {
            setNoAccessISOpen(true)
            return;
        }
        if (remainingDays <= 0) {
            setShowWarnning(true);
            return;
        }

        const hasLinkPermission = hasPermission("/lr/addlr", allMenu, 'web', 'link');
        if (!hasLinkPermission) {
            toast.error("You don't have permission to access this page");
            return;
        }

        const obj = {
            ...getFiltersValues,
            pod_status: object,
            lr_status: 0,
            lr_pagination: 1
        }
        dispatch(updateInputValue(obj))
        navigate('/lr/addlr');
    }


    const handleApplyNavigation = (link, label = "") => {
        if (noWebAccess) {
            setNoAccessISOpen(true);
            return;
        }

        if (remainingDays <= 0) {
            setShowWarnning(true);
            return;
        }

        const hasLinkPermission = hasPermission(link, allMenu, 'web', 'link');
        const hasLabelPermission = label ? hasPermission(label, allMenu, 'web', 'label') : false;

        if (!hasLinkPermission && !hasLabelPermission) {
            toast.error("You don't have permission to access this page");
            return;
        }

        navigate(link);
    };

    const handleApplyNavigationApprove = (link, label = "") => {
        if (noWebAccess) {
            setNoAccessISOpen(true);
            return;
        }

        if (remainingDays <= 0) {
            setShowWarnning(true);
            return;
        }
        const hasLinkPermission = hasPermission("/payment_approval", allMenu, 'web', 'link');

        if (!hasLinkPermission) {
            toast.error("You don't have permission to access this page");
            return;
        }

        navigate(link);
    };


    useEffect(() => {

        if (dashboardFilterClear) {
            const obj = {
                ...getFiltersValues,
                branch_id: {}, // { label: "All", value: "" },
                lr_status: 0,
                lr_pagination: 1
            }
            dispatch(updateInputValue(obj))
            setDashboardFilterClear(false);
        }
    }, [dashboardFilterClear])

    const ewayBillApplyFilter = (value) => {

        if (noWebAccess) {
            setNoAccessISOpen(true);
            return;
        }

        if (remainingDays <= 0) {
            setShowWarnning(true);
            return;
        }


        const hasLinkPermission = hasPermission("/ebill", allMenu, 'web', 'link');

        if (!hasLinkPermission) {
            toast.error("You don't have permission to access this page");
            return;
        }

        const obj = {
            ...getEwayBillFilters,
            branch_id: getFiltersValues?.branch_id?.value ? getFiltersValues?.branch_id?.value : '',
            // start_date: selectedRange?.startDate,
            // end_date: selectedRange?.endDate,
            eway_bill_status: value,
            offset: 1
        }
        dispatch(updateEwayBillFilters(obj));
        navigate('/ebill');
    }


    const paymentVerifyHandle = async (orderId) => {
        const payload = {
            order_id: orderId,
            company_id: StorageServices.getCompanyId(),
        };

        try {
            // setVerifyLoading(true);

            let res;

            res = await paymentVerifyApi(payload);

            if (res?.responseCode === 200) {
                const { status } = res.data;

                if (status === 1) {

                    setShowSuccess(true);
                    toast.success("Payment completed successfully!");
                    setTimeout(() => {
                        setShowSuccess(false);

                    }, 3000);

                } else if (status === 0) {

                    setShowPending(true);
                    toast.error("Payment is still pending. Please wait or contact support.");
                    setTimeout(() => {
                        setShowPending(false);

                    }, 3000);

                } else {
                    // Payment failed
                    setShowFailure(true);
                    toast.error("Payment failed. Please try again or contact support.");
                    setTimeout(() => {
                        setShowFailure(false);
                    }, 3000);
                }
            } else {
                // API call failed
                setShowFailure(true);
                toast.error("Unable to verify payment. Please contact support.");
                setTimeout(() => {
                    setShowFailure(false);
                }, 3000);
            }
        } catch (error) {
            // For network errors, treat as pending in case payment actually went through
            setShowPending(true);
            toast.error("Unable to verify payment status. Please contact support if amount was debited.");
            setTimeout(() => {
                setShowPending(false);
            }, 3000);
        } finally {
            // setVerifyLoading(false);
        }
    }

    const fetchBranchList = useCallback(async (search, page, limit) => {
        try {
            const response = await getBranchListApi({
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                offset: page,
                limit,
                search,
            });

            if (response?.responseCode === 200) {
                const vendors = response?.data?.branch_list?.map((vendor) => ({
                    ...vendor,
                    label: vendor.branch,
                    value: vendor._id
                }));

                return {
                    items: vendors,
                    total: response.data.total_record || vendors.length,
                };
            }

            toast.error(response?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            return { items: [], total: 0 };
        }
    }, []);

    return (
        <div className="llt_dashboard_bx">
            {/* <div className="mb-5">
                <div className='__subscr_planUp_bx'>
                    <img src={Images.WARN_ICON.default} alt="" />
                    <div>
                        {remainingDays > 0 ? (
                            <div>
                                <h6> Your Transport 360 Plan Subscription Ends in{" "}
                             {remainingDays} {remainingDays === 1 ? "Day" : "Days"}</h6>
                            </div>
                            // <p style={{fontWeight:500, fontSize:"16px",color:"#000"}}>
                               
                            // </p>
                        ) : (
                            <p style={{ color: "red" }}>
                                Your <strong>Transport 360</strong> Plan Subscription Has Expired!
                            </p>
                        )}
                        <p>Keep your Vehicles moving, customers happy, and business on time — upgrade now (upto 20% off!)</p>
                    </div>
                    <button className='anime-btn __upGrd_btn' onClick={() => navigate('/subscription')}>Upgrade plan <IoArrowForwardOutline /></button>
                </div>
            </div> */}
            <div className="llt_dash_heading">
                <h5>Welcome {userData?.user_detail?.full_name}</h5>
                <div className="llt_dash_branch_date">
                    <div className='widthInput_dash'>
                        <CityDropdownForTrip
                            label="Branch"
                            placeholder="Branch"
                            fetchData={fetchBranchList}
                            pageSize={20}
                            selectedItem={getFiltersValues?.branch_id?.label ? getFiltersValues?.branch_id : {}}
                            onChange={(data) => onhandleSelect(data, 'branch_id')}
                            isClearOption={getFiltersValues?.branch_id?.value ? true : false}
                            isClearHandleChange={(e) => onhandleSelect({ label: "All", value: "" }, 'branch_id')}
                        // disabled={isOpen?.isDetails ? true : false}
                        // error={formError['manufacture_id.label']}
                        // errorMessage={formError['manufacture_id.label']}
                        // isAddButton={true}
                        // addButtonAction={(e) => addNewManufacturerHandler(e)}
                        />
                        {/* <CustomSelect
                            options={dropdownBranchList?.map((el) => {
                                return {
                                    label: el?.branch,
                                    value: el?._id,
                                    firm_id: el?.firm_id
                                }
                            })}
                            name="branch_id"
                            label="Select Branch"
                            placeholder="Select Branch"
                            value={getFiltersValues?.branch_id?.label ? getFiltersValues?.branch_id : {}}
                            onSelect={(data) => onhandleSelect(data, 'branch_id')}
                        /> */}
                    </div>

                    <div>
                        <CommonDateRange
                            initialStartDate={getFiltersValues?.start_date}
                            initialEndDate={getFiltersValues?.end_date}
                            onApply={handleApply}
                            isDefaultToday={true}
                        // datePrefield={(!dashboardData?.start_date && !dashboardData?.end_date) ? false : true}
                        />
                    </div>

                </div>
            </div>

            <div className='__warnMain_bxs'>
                <BsExclamationCircle />
                <p>Action required</p>
                <div className='__req_actTags'>{dashboardData?.lr_status?.pod_overdue > 0 ? dashboardData?.lr_status?.pod_overdue : 0} <span> PODs overdue </span></div>
                <div className='__req_actTags'>{dashboardData?.vehicle_doc_status?.expired > 0 ? dashboardData?.vehicle_doc_status?.expired : 0} <span> Documents expired</span></div>
                <div className='__req_actTags'>{dashboardData?.lr_status?.expiring_today > 0 ? dashboardData?.lr_status?.expiring_today : 0} <span> E-way bills expiring today</span></div>
            </div>

            <div className="row dash_row">
                <div className="col-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="llt_dash_lr_stats">
                        <h6>LR Status</h6>

                        <div className="llt_dash_lr_r1">
                            <div className="llt_dash_lr_sts_one">
                                <span className="llt_dash_span_one"></span> <p>LR Created</p>
                            </div>
                            <button className="llt_dash_btn_one" onClick={() => statusWithNavigate(0, true)}>{dashboardData?.lr_status?.lr_created}</button>
                        </div>
                        <div className="llt_dash_lr_r1">
                            <div className="llt_dash_lr_sts_one">
                                <span className="llt_dash_span_two"></span> <p>LR Pending</p>
                            </div>
                            <button className="llt_dash_btn_two" onClick={() => statusWithNavigate(1, false)}>{dashboardData?.lr_status?.pending_lr}</button>
                        </div>
                        <div className="llt_dash_lr_r1">
                            <div className="llt_dash_lr_sts_one">
                                <span className="llt_dash_span_three"></span>
                                <p>In-Transit</p>
                            </div>
                            <button className="llt_dash_btn_three" onClick={() => statusWithNavigate(3, false)}>{dashboardData?.lr_status?.in_transit}</button>
                        </div>
                        <div className="llt_dash_lr_r1">
                            <div className="llt_dash_lr_sts_one">
                                <span className="llt_dash_span_four"></span>
                                <p>At Party Point</p>
                            </div>
                            <button className="llt_dash_btn_four" onClick={() => statusWithNavigate(4, false)}>{dashboardData?.lr_status?.at_party_point}</button>
                        </div>
                        <div className="llt_dash_lr_r1">
                            <div className="llt_dash_lr_sts_one">
                                <span className="llt_dash_span_five"></span> <p>Delivered</p>
                            </div>
                            <button className="llt_dash_btn_five" onClick={() => statusWithNavigate(5, false)}>{dashboardData?.lr_status?.delivered}</button>
                        </div>
                        <div className="llt_dash_lr_r1">
                            <div className="llt_dash_lr_sts_one">
                                <span className="llt_dash_span_six"></span> <p>Bill Raised</p>
                            </div>
                            <button className="llt_dash_btn_six" onClick={() => statusWithNavigate(6)}>{dashboardData?.lr_status?.bill_raised}</button>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="llt_dash_lr_stats" style={{ position: 'relative' }}>
                        <h6 style={{ marginBottom: '0px', paddingBottom: '0px' }}>Dispatch Summary</h6>
                        <div className="llt_dash_dispatch">

                            <PieCharts
                                dataList={
                                    chartData?.length > 0
                                        ? chartData
                                        : []
                                }
                            />
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="llt_dash_pod_vehicle">
                        <div className="llt_dash_pod">
                            <h6 className='__headLine_dp'>POD Status</h6>
                            <div className="llt_dash_pod_data">
                                <div
                                    className="llt_dash_pod_d1 _avPointer"
                                    onClick={() => handleApplyFilter({ value: 2, label: "Received" })}>
                                    <div className='__growUp_pod'>
                                        <img src={Images.GRAPHUP.default} alt="graph up" />
                                    </div>
                                    <div>
                                        <h5>{dashboardData?.lr_status?.pod_received}</h5>
                                        <p>POD Received</p>
                                    </div>
                                </div>
                                <div
                                    className="llt_dash_pod_d1 _avPointer"
                                    onClick={() => handleApplyFilter({ value: 1, label: "Pending" })}>
                                    <div className='__pendingTime_pod'>
                                        <img src={Images.PENDING_HISPORY.default} alt="pending pod" />
                                    </div>
                                    <div>
                                        <h5>{dashboardData?.lr_status?.pod_pending}</h5>
                                        <p>POD Pending</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="llt_dash_pod">
                            <h6 className='__headLine_dp'>Vehicle Document</h6>
                            <div className="llt_dash_pod_data">
                                <div className="llt_dash_vehicle_d1">
                                    <div className='__expireVhl_doc'>
                                        <img src={Images.NEAR_EXPIRE_VHL.default} alt="Near Expiry" />
                                    </div>
                                    <div>
                                        <p>Expiring soon</p>
                                        <h6> {dashboardData?.vehicle_doc_status?.expiring_soon} </h6>
                                    </div>
                                </div>
                                <div className="llt_dash_vehicle_d1">
                                    <div className='__expireVhl_doc'>
                                        <img src={Images.EXPIRED_VHL.default} alt="Expired Vehicle" />
                                    </div>
                                    <div>
                                        <p>Expired</p>
                                        <h6> {dashboardData?.vehicle_doc_status?.expired} </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="__dash_quick_access">
                        <h6 className='__headLine_dp'>Quick Access</h6>

                        <div className='__dash_quickBtn_bx' >
                            <Link>
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/plan/planlist')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_PLAN.default} alt="My Plans" />
                                    </div>
                                    My Plans
                                </button>
                            </Link>
                            <Link >
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/lr/addlr',)}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_LR.default} alt="LR/ Bilty" />
                                    </div>
                                    LR/ Bilty
                                </button>
                            </Link>
                            <Link>
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/trip/addtrip')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_TRIP.default} alt="Trip" />
                                    </div>
                                    Trip
                                </button>
                            </Link>
                            <Link >
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/ebill')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_EWAY.default} alt="Eway" />
                                    </div>
                                    Eway
                                </button>
                            </Link>
                            <Link >
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/account/consignor')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_PARTY.default} alt="Party" />
                                    </div>
                                    Party
                                </button>
                            </Link>
                            <Link >
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/account/supplier')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_SUPPLIER.default} alt="Supplier" />
                                    </div>
                                    Supplier
                                </button>
                            </Link>
                            <Link >
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/account/driver')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_DRIVER.default} alt="Driver" />
                                    </div>
                                    Driver
                                </button>
                            </Link>
                            <Link>
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/account/vehicle')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_TRUCK.default} alt="Trucks" />
                                    </div>
                                    Trucks
                                </button>
                            </Link>
                            <Link >
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/accounting/staff', "Staff")}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_PARTY.default} alt="Staff" />
                                    </div>
                                    Staff
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="llt_dash_payment">
                        <h5>Account Details</h5>
                        <div className="llt_dash_Account_bx">
                            {dashboardData?.accounting_list?.length > 0 ? dashboardData?.accounting_list?.map((item, indx) => {

                                return (

                                    <Link className="llt_dash_Account_bx_1" style={{ "textDecoration": "none" }} key={indx}
                                        onClick={() => handleApplyNavigation("/accounting/transactions/bank_transaction_list", "Accounting")}
                                        state={{
                                            data: {
                                                account_id: item?._id,
                                            },
                                        }}>
                                        <p>{item?.bank}</p>
                                        <a href=""> ₹ {item?.balance ? item?.balance?.toFixed(2) : 0.00} </a>
                                    </Link>
                                )
                            }) :
                                <>
                                    <div className="llt_dash_Account_bx_1">
                                        <p>Axis Bank</p>
                                        <a href=""> No bank found </a>
                                    </div>
                                    <div className="llt_dash_Account_bx_1">
                                        <p>Kotak Bank</p>
                                        <a href=""> No bank found </a>
                                    </div>
                                    <div className="llt_dash_Account_bx_1">
                                        <p>Yes Bank</p>
                                        <a href=""> No bank found </a>
                                    </div>
                                    <div className="llt_dash_Account_bx_1">
                                        <p>Axis Bank</p>
                                        <a href=""> No bank found </a>
                                    </div>
                                    <div className="llt_dash_Account_bx_1">
                                        <p>Kotak Bank</p>
                                        <a href=""> No bank found </a>
                                    </div>
                                    <div className="llt_dash_Account_bx_1">
                                        <p>Yes Bank</p>
                                        <a href=""> No bank found </a>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="llt_dash_payment" style={{ overflow: 'hidden' }}>
                        <h5>Payment Approval</h5>
                        <div className="llt_dash_payment_bx">
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=1')}>
                                <div className='__dashPay_pending'><h6>{dashboardData?.payment_approval_status?.pending}</h6></div>
                                <p>Pending</p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=2')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.hold}</h6></div>
                                <p>On Hold</p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=3')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.approved}</h6></div>
                                <p>Approved</p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=6')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.payment_from_CB}</h6></div>
                                <p> Pay from Bank </p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=7')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.pending}</h6></div>
                                <p> Pending from Bank </p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=8')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.CB_transaction_initiated}</h6></div>
                                <p> Transaction Initiated </p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=9')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.CB_transaction_failed}</h6></div>
                                <p>Transaction Failed</p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=3')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.CB_under_approval}</h6></div>
                                <p> Under Approval </p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=5')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.completed}</h6></div>
                                <p>Completed</p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=4')}>
                                <div className='__dashPay_reject'><h6>{dashboardData?.payment_approval_status?.rejected}</h6></div>
                                <p>Rejected</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="llt_dash_payment">
                        <h5> EWay Bill Status </h5>
                        <div className="llt_dash_eway_bx">
                            <div className="llt_dash_eway_bx_1 llt_dasheway_bill_1 _avPointer" onClick={() => ewayBillApplyFilter(2)}>
                                <h6>{dashboardData?.lr_status?.active_eway > 0 ? dashboardData?.lr_status?.active_eway : 0}</h6>
                                <p> Active Eway </p>
                            </div>

                            <div className="llt_dash_eway_bx_1 llt_dasheway_bill_2 _avPointer" onClick={() => ewayBillApplyFilter(1)}>
                                <h6>{dashboardData?.lr_status?.without_eway > 0 ? dashboardData?.lr_status?.without_eway : 0}</h6>
                                <p> Without Eway </p>
                            </div>

                            <div className="llt_dash_eway_bx_1 llt_dasheway_bill_3 _avPointer" onClick={() => ewayBillApplyFilter(4)}>
                                <h6>{dashboardData?.lr_status?.expiring_today > 0 ? dashboardData?.lr_status?.expiring_today : 0}</h6>
                                <p> Expiring Today </p>
                            </div>

                            <div className="llt_dash_eway_bx_1 llt_dasheway_bill_4 _avPointer" onClick={() => ewayBillApplyFilter(5)}>
                                <h6>{dashboardData?.lr_status?.expired > 0 ? dashboardData?.lr_status?.expired : 0}</h6>
                                <p> Expired </p>
                            </div>

                            {/* <div className="llt_dash_eway_bx_1 llt_dasheway_bill_5">
                                <h6>{dashboardData?.lr_status?.not_found > 0 ? dashboardData?.lr_status?.not_found : 0}</h6>
                                <p>Not Found</p>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>

        </div >
    )
}

export default MainDashboard